var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9291 10.644V12.0629C9.9291 12.251 9.85435 12.4315 9.72131 12.5645C9.58826 12.6976 9.40782 12.7723 9.21967 12.7723H4.25366L2.12537 14.9006V7.8063C2.12537 7.61815 2.20011 7.4377 2.33315 7.30466C2.4662 7.17161 2.64664 7.09687 2.8348 7.09687H4.25366M14.8951 9.93459L12.7668 7.8063H7.80081C7.61265 7.8063 7.43221 7.73156 7.29916 7.59851C7.16612 7.46547 7.09138 7.28502 7.09138 7.09687V2.84029C7.09138 2.65214 7.16612 2.47169 7.29916 2.33865C7.43221 2.2056 7.61265 2.13086 7.80081 2.13086H14.1857C14.3738 2.13086 14.5543 2.2056 14.6873 2.33865C14.8204 2.47169 14.8951 2.65214 14.8951 2.84029V9.93459Z",
    stroke: "currentColor",
    strokeWidth: 1.41886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.2c4b5c0620ea960c58a3800e94d1e9fa.svg";
export { ForwardRef as ReactComponent };